import React, { useState, useEffect } from 'react';
import styles from './Nav.module.css';

const NAV_LINKS = [
  { label: 'About',      id: 'about' },
  { label: 'Experience', id: 'experience' },
  { label: 'Skills',     id: 'skills' },
  { label: 'Projects',   id: 'projects' },
  { label: 'Contact',    id: 'contact' },
] as const;

const scrollTo = (id: string): void => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};

export default function Nav(): React.ReactElement {
  const [scrolled, setScrolled] = useState<boolean>(false);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const handleNav = (id: string) => {
    setMenuOpen(false);
    setTimeout(() => scrollTo(id), 50);
  };

  const navClass = `${styles.nav}${scrolled ? ` ${styles.navScrolled}` : ''}`;

  return (
    <>
      <nav className={navClass} aria-label="Main navigation">
        <div className={styles.logo} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          TM<span className={styles.logoAccent}>.</span>
        </div>

        <ul className={styles.links} role="list">
          {NAV_LINKS.map(({ label, id }, i) => (
            <li key={id}>
              <button className={styles.link} onClick={() => handleNav(id)}>
                <span className={styles.linkNum}>0{i + 1}.</span>{label}
              </button>
            </li>
          ))}
        </ul>

        <button className={styles.cta} onClick={() => handleNav('contact')}>Hire Me</button>

        <button
          className={`${styles.hamburger}${menuOpen ? ` ${styles.hamburgerOpen}` : ''}`}
          onClick={() => setMenuOpen((o) => !o)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          <span /><span /><span />
        </button>
      </nav>

      <div className={`${styles.mobileMenu}${menuOpen ? ` ${styles.mobileMenuOpen}` : ''}`} role="dialog" aria-modal="true">
        {NAV_LINKS.map(({ label, id }, i) => (
          <button key={id} className={styles.mobileLink} onClick={() => handleNav(id)}>
            <span className={styles.mobileLinkNum}>0{i + 1}.</span>{label}
          </button>
        ))}
        <button className={styles.mobileCta} onClick={() => handleNav('contact')}>Hire Me</button>
      </div>
    </>
  );
}
